import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
// Animations
import { slideInDownAnimation } from '../../../app/app.animation';
// Common
import { AngularMaterialService, ErrorParseService, IProjectTask, LGEDataService } from '../../../commons';
// State
import { Store } from '@ngrx/store';
import * as fromProjectTask from './state/project-task.selectors';
import * as ProjectTaskAction from './state/project-task.actions';
import * as lgeApp from '../../../app/state/app.actions';
import { Observable, Subscription, skipWhile } from 'rxjs';


@Component({
    selector: 'project-task-screen',
    templateUrl: 'project-task.component.html',
    styleUrls: ['project-task.scss'],
    animations: [slideInDownAnimation],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectTaskExtScreenComponent implements OnInit, OnDestroy {
    @Input() pending$: Observable<boolean>;
    pendingSubscription: Subscription;
    pending: boolean;
    @Input() error$: Observable<string | null>;
    errorSubscription: Subscription;
    error: string | null;
    @Input() stateData$: Observable<IProjectTask | null>;
    stateDataSubscription: Subscription;
    stateData: IProjectTask | null;

    getData: string = 'PROJ_TASK_PLUS';    // need change

    projectTaskCCDetails = [];
    projectTaskCIDetails = [];
    projectTaskPPDetails = [];
    isNullProjectTaskDetails: boolean = false;
    isLoadingProjectTaskDetails: boolean = false;
    showErrorProjectTaskDetails: boolean = false;
    errorMessageProjectTaskDetails: string;

    // @ViewChild(MatPaginator) paginator: MatPaginator;
    // @ViewChild(MatSort) sort: MatSort;

    // displayedColumns = ['company', 'organization', 'account', 'project', 'task'];
    // dataSource: MatTableDataSource<any>;

    constructor(
        private store: Store<fromProjectTask.State>,
        private ref: ChangeDetectorRef,
        private fb: FormBuilder,
        private ams: AngularMaterialService,
        private errorParse: ErrorParseService,
        private _dataService: LGEDataService
    ) {
        this.selectState();
        this.createForms();
        // this.dataSource = new MatTableDataSource([]);
    }


    ngOnInit() {
        this.startSubscriptions();
        this.getActiveProjectTaskDataCC();
        // this.getActiveProjectTaskDataCI();
        // this.getActiveProjectTaskDataPFTP();
    }
    onTabChange(val) {
        if (val === 1 && this.projectTaskCIDetails.length === 0) {
            this.ams.showLoader('Loading...');
            this.getActiveProjectTaskDataCI();
        } else if (val === 2 && this.projectTaskPPDetails.length === 0) {
            this.ams.showLoader('Loading...');
            this.getActiveProjectTaskDataPFTP();
        }
        // (selectChange)='onSelectChange($event)'  // HTML <mat-tab-group>
        // // console.log(event)
    }
    getActiveProjectTaskDataCC() {
        this.isLoadingProjectTaskDetails = true;
        this._dataService.ProjectTaskInfo_GetActiveByName([this.getData, 'CC']) // change ws call
            .subscribe({
                next: data => {
                    if (data) {
                        this.projectTaskCCDetails = data;
                        this.isLoadingProjectTaskDetails = false;
                        // console.log('selected project-task list CC');
                        // console.log(data);
                        // this.dataSource = new MatTableDataSource(data);
                        this.ref.markForCheck();
                        this.ref.detectChanges();
                        this.ams.closeDialog();
                    } else {
                        // console.log(data);
                        this.isNullProjectTaskDetails = true;
                        this.errorMessageProjectTaskDetails = 'There is not any selected project-task';
                        this.ref.markForCheck();
                        this.ref.detectChanges();
                        this.ams.closeDialog();
                    }
                },
                error: error => {
                    // console.log(error);
                    this.isLoadingProjectTaskDetails = false;
                    this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                    this.showErrorProjectTaskDetails = true;
                    this.errorMessageProjectTaskDetails = 'Error, Please try again later!';
                    this.ref.markForCheck();
                    this.ref.detectChanges();
                    this.ams.closeDialog();
                }
            }
            );
    }

    getActiveProjectTaskDataCI() {
        this.isLoadingProjectTaskDetails = true;
        this._dataService.ProjectTaskInfo_GetActiveByName([this.getData, 'CI']) // change ws call
            .subscribe({
                next: data => {
                    if (data) {
                        this.projectTaskCIDetails = data;
                        this.isLoadingProjectTaskDetails = false;
                        // console.log('selected project-task list CI');
                        // console.log(data);
                        // this.dataSource = new MatTableDataSource(data);
                        this.ref.markForCheck();
                        this.ref.detectChanges();
                        this.ams.closeDialog();
                    } else {
                        // console.log(data);
                        this.isNullProjectTaskDetails = true;
                        this.errorMessageProjectTaskDetails = 'There is not any selected project-task';
                        this.ref.markForCheck();
                        this.ref.detectChanges();
                        this.ams.closeDialog();
                    }
                },
                error: error => {
                    // console.log(error);
                    this.isLoadingProjectTaskDetails = false;
                    this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                    this.showErrorProjectTaskDetails = true;
                    this.errorMessageProjectTaskDetails = 'Error, Please try again later!';
                    this.ref.markForCheck();
                    this.ref.detectChanges();
                    this.ams.closeDialog();
                }
            }
            );
    }

    getActiveProjectTaskDataPFTP() {
        this.isLoadingProjectTaskDetails = true;
        this._dataService.ProjectTaskInfo_GetActiveByName([this.getData, 'PP']) // change ws call
            .subscribe({
                next: data => {
                    if (data) {
                        this.projectTaskPPDetails = data;
                        this.isLoadingProjectTaskDetails = false;
                        // console.log('selected project-task list PFTP');
                        // console.log(data);
                        // this.dataSource = new MatTableDataSource(data);
                        this.ref.markForCheck();
                        this.ref.detectChanges();
                        this.ams.closeDialog();
                    } else {
                        // console.log(data);
                        this.isNullProjectTaskDetails = true;
                        this.errorMessageProjectTaskDetails = 'There is not any selected project-task';
                        this.ref.markForCheck();
                        this.ref.detectChanges();
                        this.ams.closeDialog();
                    }
                },
                error: error => {
                    // console.log(error);
                    this.isLoadingProjectTaskDetails = false;
                    this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                    this.showErrorProjectTaskDetails = true;
                    this.errorMessageProjectTaskDetails = 'Error, Please try again later!';
                    this.ref.markForCheck();
                    this.ref.detectChanges();
                    this.ams.closeDialog();
                }
            }
            );
    }

    editProjectTaskListCC() {
        this.ams.showLoader('Loading...');
        this._dataService.ProjectTaskInfo_GetByName(this.getData)   // need change
            .subscribe({
                next: data => {
                    // console.log('project-task list');
                    // console.log(data);
                    this.ams.closeDialog();
                    this.ams.showProjectTaskDetails('Project-Task (CC)', '', data);
                    this.ams.projectTask.afterClosed().subscribe(result => {
                        if (result) {
                            // console.log('selected project-task CC');
                            // console.log(result);
                            this.ams.showLoader('Saving...');
                            this._dataService.ProjectTaskInfo_Update([result, 'CC'])
                                .subscribe({
                                    next: data => {
                                        // console.log(data);
                                        this.ams.closeDialog();
                                        this.ref.markForCheck();
                                        if (data === 'Success') {
                                            this.getActiveProjectTaskDataCC();
                                            this.ref.markForCheck();
                                            this.ref.detectChanges();
                                            this.ams.closeDialog();
                                        }
                                    },
                                    error: error => {
                                        // console.log(error);
                                        this.ams.closeDialog();
                                        this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                                        this.ref.markForCheck();
                                        this.ref.detectChanges();
                                        this.ams.closeDialog();
                                    }
                                }
                                );
                        }
                    });
                },
                error: error => {
                    // console.log(error);
                }
            });
    }

    editProjectTaskListCI() {
        this.ams.showLoader('Loading...');
        this._dataService.ProjectTaskInfo_GetByName(this.getData)   // need change
            .subscribe({
                next: data => {
                    // console.log('project-task list');
                    // console.log(data);
                    this.ams.closeDialog();
                    this.ams.showProjectTaskDetails('Project-Task (CI)', '', data);
                    this.ams.projectTask.afterClosed().subscribe(result => {
                        if (result) {
                            // console.log('selected project-task CI');
                            // console.log(result);
                            this.ams.showLoader('Saving...');
                            this._dataService.ProjectTaskInfo_Update([result, 'CI'])
                                .subscribe({
                                    next: data => {
                                        // console.log(data);
                                        this.ams.closeDialog();
                                        this.ref.markForCheck();
                                        if (data === 'Success') {
                                            this.getActiveProjectTaskDataCI();
                                            this.ref.markForCheck();
                                            this.ref.detectChanges();
                                            this.ams.closeDialog();
                                        }
                                    },
                                    error: error => {
                                        // console.log(error);
                                        this.ams.closeDialog();
                                        this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                                        this.ref.markForCheck();
                                        this.ref.detectChanges();
                                        this.ams.closeDialog();
                                    }
                                }
                                );
                        }
                    });
                },
                error: error => {
                    // console.log(error);
                }
            });
    }

    editProjectTaskListPFTP() {
        this.ams.showLoader('Loading...');
        this._dataService.ProjectTaskInfo_GetByName(this.getData)   // need change
            .subscribe({
                next: data => {
                    // console.log('project-task list');
                    // console.log(data);
                    this.ams.closeDialog();
                    this.ams.showProjectTaskDetails('Project-Task (PFTP)', '', data);
                    this.ams.projectTask.afterClosed().subscribe(result => {
                        if (result) {
                            // console.log('selected project-task PFTP');
                            // console.log(result);
                            this.ams.showLoader('Saving...');
                            this._dataService.ProjectTaskInfo_Update([result, 'PP'])
                                .subscribe({
                                    next: data => {
                                        // console.log(data);
                                        this.ams.closeDialog();
                                        this.ref.markForCheck();
                                        if (data === 'Success') {
                                            this.getActiveProjectTaskDataPFTP();
                                            this.ref.markForCheck();
                                            this.ref.detectChanges();
                                            this.ams.closeDialog();
                                        }
                                    },
                                    error: error => {
                                        // console.log(error);
                                        this.ams.closeDialog();
                                        this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                                        this.ref.markForCheck();
                                        this.ref.detectChanges();
                                        this.ams.closeDialog();
                                    }
                                }
                                );
                        }
                    });
                },
                error: error => {
                    // console.log(error);
                }
            });
    }

    // Select state
    selectState(): void {
        this.pending$ = this.store.select(fromProjectTask.getProjectTaskScreenPending);
        this.stateData$ = this.store.select(fromProjectTask.getProjectTaskState);
        this.error$ = this.store.select(fromProjectTask.getProjectTaskScreenError).pipe(skipWhile(error => error === undefined || error === null || error === ''));
    }

    displayLoader(pending: boolean): void {
        if (pending) {
            this.ams.showLoader("Loading");
        } else {
            this.ams.closeDialog().then(() => {
                if (this.error !== null && this.error !== undefined && this.error !== '') {
                    this.displayError(this.error);
                }
            });
        }
    }

    displayError(error: any): void {
        let errorMessage;
        if (this.errorParse.foundKeyWord(error, "CORPCOMMONWS")) {
            errorMessage = this.errorParse.translateCCError(error);
        } else {
            errorMessage = error instanceof Object ? error.message : error;
        }
        this.ams.showAlert("Loading Error", errorMessage);
        this.ams.alert.afterClosed().subscribe(result => {
            this.store.dispatch(new ProjectTaskAction.ProjectTaskScreenErrorReset());
        });
    }

    // Create reactive forms
    createForms(): void {

    }
    // Opens sidenav if on mobile
    public openSidenav(): void {
        this.store.dispatch(new lgeApp.OpenSidenav());
    }
    // Subscribe to state data and mark it for changes
    startSubscriptions(): void {
        this.pendingSubscription = this.pending$
            .subscribe(data => {
                this.pending = data;
                this.displayLoader(this.pending);
                this.ref.markForCheck();
            });
        this.errorSubscription = this.error$
            .subscribe(data => {
                this.error = data;
                this.ref.markForCheck();
            });
        this.stateDataSubscription = this.stateData$
            .subscribe(data => {
                this.stateData = data;
                this.ref.markForCheck();
            });
    }
    // Unsubscribe from state data changes
    endSubscriptions(): void {
        this.pendingSubscription.unsubscribe();
        this.errorSubscription.unsubscribe();
        this.stateDataSubscription.unsubscribe();
    }

    ngOnDestroy() {
        this.endSubscriptions();
    }


}